// 날짜가 없거나 파싱 불가면 null — 대체 문구는 호출부에서 번역해 넣을 것
// (날짜 문자열을 t() 에 넘기면 매번 미해결 키 조회가 된다). statusMapping 의 formatCardDate 와 같은 계약.
export const formatApprovalDate = (iso?: string): string | null => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const yyyy = String(d.getFullYear());
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

// 빈값 → '', 파싱 불가 → 원본 그대로.
export const formatApprovalDateTime = (s?: string): string => {
  if (!s) return '';
  const normalized = s.includes('T') ? s : s.replace(' ', 'T');
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return s;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  const ss = String(d.getSeconds()).padStart(2, '0');
  return `${y}-${m}-${day} ${hh}:${mm}:${ss}`;
};
